











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class PersonWidgetWrapper extends Vue {
  @Prop() alert!: boolean
}
